export default __webpack_public_path__ + "static/media/refresh_bulk.fae2cad4.svg";